import React, {useState, useEffect, useRef} from 'react';
import {json, useNavigate, useNavigation, useLocation} from "react-router-dom";
import {$CombinedState} from 'redux';
import Header from "./templates/header";
import LeftBar from "./templates/left_bar";

import Loader from '../common/Loader'
import ApiService from "../../services/api.service";

import {addFarmerInfo} from "../../store/actions/updateFarmerInfo";

import {useDispatch, useSelector} from "react-redux";

import {addWalletInfo} from '../../store/actions/saveWalletInfo'

import {selectedWalletInfo} from '../../store/actions/selectedWallet'

import {productReducer} from "../../store/reducers/ProductReducer";
import ErrorMag from "../common/ErrorMag";

import BreadCrumbs from '../common/BreadCrumbs';
import { toTitleCase } from './summary';
import { currencyFormatter } from '../common/Utils';
import {
    Container,
    CssBaseline
} from "@mui/material";

import SchoolsSelector from "../common/SchoolsSelector";
import {cartReducer} from "../../store/reducers/SelectedProductReducer";
const SchoolFeePayment = ({ navigation }) => {
    const navigate = useNavigate();
    const [showSelect, setShowSelect] = useState(0);
    const location = useLocation();
    const [farmerId, setFarmerId] = useState((location.state && location.state.farmerid !== undefined) ? location.state.farmerid : "");
    const walletinfo = useSelector((state) => { try{return JSON.parse(state.wallet_info);} catch(e){return {}}  });
    const wallet_more_info = useSelector((state) => { try{return state.wallet_more_info} catch(e){return {}}  });
    const [balance_err, setBalanceErr] = useState();
    const [loader, showLoader] = useState(false);
    const [isVisible, showisVisible] = useState(false);
    const[steps, setSteps] = useState([
        { 'title': 'Subsidy Services','name':'transactions', 'path': '/transactions', 'current': false },
        { 'title': 'Payment Details','name':'paymentdtls', 'path': '//school-fees', 'current': true },
    ])
    const [selectedSchool, setSelectedSchool] = useState("")
    const [selectedSchoolname, setSelectedSchoolName] = useState("")
    const [selectedSchoolcode, setSelectedSchoolCode] = useState("")
    const [closeSchoolSelector, setCloseSelector] = useState(true)
    const [error, setError] = useState('');
    const [noProductserror, setnoProductserror] = useState('')
    const [verifyClass, setVerifyClass] = useState('grayout')
    const [cardInfo, setCardInfo] = useState({})
    const [disabledNav, disabledNavigate] = useState(true)
    const wallets = useSelector((state) => state.wallets)
    const [wallet, setWallet] = useState( (location.state && location.state.walletId !== undefined) ? wallets.filter((item) => item.walletReferenceCode === location.state.walletId)[0] : {})
    const [bal_err, setBalError] = useState(false);
    const [schools, setSchools] = useState([]);
    const dispatch = useDispatch();
    const products = useSelector((state) => { return state.products; });
    const farmer = useSelector((state) => { return state.farmer; });
    const wallet_info = useSelector((state) => { try{return JSON.parse(state.wallet_info);} catch(e){return {}}  });
    const userCredentials = useSelector((state) => { return state.userCredentials; });
    const [errorMagData, seterrorMagData] = useState({})
    const[selectedwallet, setWalletName]=useState('')
    const [selectProductsButton, setSelectProductsButton] = useState('grayout');
    const [triggerValidations, setTriggerValidations] = useState(false)
    const handleVerify = (e) => {
        e.preventDefault();
        showLoader(true)

        ApiService.get("/farmer/validate?customerId=" + farmerId).subscribe((res) => {

            if (res.data !== undefined && res.data !== null) {
                showLoader(false)
                dispatch(addFarmerInfo(res.data ? res.data : { idNumber: farmerId }))
                getWallets();
                //call wallets api
                setShowSelect(1)
            } else if (res.response !== undefined && res.response !== null) {
                showLoader(false)
                if (res.response.data.status === 400) {
                    setError(res.response.data.error ? res.response.data.error : "Farmer ID not found")
                    return
                }
                setError("Farmer ID not found");
                return
            } else {
                showLoader(false)
                setError("An error occurred");
            }
        })

    }

    useEffect(() => () => { window.history.replaceState({}, document.title);},[])

    const getWallets = () => {
        ApiService.get("/farmer/program_wallets").subscribe((res) => {
            if (res !== undefined && res !== null) {
                dispatch(addWalletInfo(res.data))
            }
        })
    }

    const getCardInfo = (customer_id, walletRef, walletName) => {
        ApiService.get("/farmer/card?customerId=" + customer_id + "&walletReferenceCode=" + walletRef).subscribe((res) => {
            try {
                if (res !== undefined && res !== null) {
                    if (res.data !== undefined && res.data !== null) {
                        dispatch(selectedWalletInfo(res.data))
                        setCardInfo(res.data)
                        checkProducts(userCredentials.MerchantID, res.data.PAN, walletRef)
                    }
                }

            } catch (err) {
                throw JSON.stringify(err)
            }
        })
    }


    const handleOnchange = (val) => {
        val.length >= 6 ? setVerifyClass("rm") : setVerifyClass('grayout')
    }
    const handleSelect = (e) => {
        e.preventDefault();
        if (Number(wallet_info.AvailableAmount)<=0) {
            const errorDtl = {
                err_name: "invalid_bal",
                err_title: "Insufficient Wallet Balance",
                err_desc: `The Selected ${toTitleCase(selectedwallet)} wallet has insufficient balance to complete the transaction. Please adjust the selected products.`,
                err_w_bal: currencyFormatter(wallet_info.AvailableAmount),
                order_amt: "Your Balance should be greater than 0"
            }
            seterrorMagData(errorDtl)
            setBalError(true);
            return;
        }
        navigate("/select-products", { state: { merchantCode: "POSMR002337", walletAccountNumber: "6910400169687447", walletReferenceCode: wallet.walletReferenceCode, famerid: farmerId } });

    }

    const checkProducts = (merchantCode, walletAccountNumber, walletReferenceCode) => {
        showLoader(true)
        let payload = { merchantCode: merchantCode, walletAccountNumber: walletAccountNumber, walletReferenceCode: walletReferenceCode }
        ApiService.post("/farmer/products", payload).subscribe((res) => {
            if (res !== undefined && res !== null) {
                showLoader(false)
                if (res.data !== undefined && res.data !== null) {
                    if (Object.keys(res.data).length > 0) {
                        disabledNavigate(false)
                        setSelectProductsButton('')
                        dispatch(productReducer(res.data))
                        setnoProductserror('')
                        return
                    } else {
                        setnoProductserror("No products for this wallet")
                        return
                    }
                } else if (res.response !== undefined && res.response !== null) {
                    if (res.response.data && res.response.data.status && res.response.data.status === 400) {
                        setnoProductserror(res.response.data.error.message)
                        return
                    }
                }
                setSelectProductsButton('grayout')
                setnoProductserror("Unable to check products. Try again later")
                return
            }
            showLoader(false)
            setSelectProductsButton('grayout')
            setnoProductserror("Unable to check farmer's products, Try again")
            return
        })
    }

    const productsChecker = (customer_id, walletRef, walletName) => {
        showLoader(true)
        disabledNavigate(true)
        dispatch(selectedWalletInfo({}))
        ApiService.get("/farmer/loadproduct?customerId="+customer_id+"&walletReferenceCode="+walletRef).subscribe((res) => {
            if (res !== undefined && res !== null) {
                showLoader(false)
                if (res.data !== undefined && res.data !== null) {
                    let products = res.data.products ? res.data.products : [{}]
                    let walletinfo = res.data.account ? res.data.account : {}
                    if(Object.keys(walletinfo).length == 0) {
                        setnoProductserror("Wallet Account Error")
                        showLoader(false)
                        return
                    }
                    if (products.length == 0) {
                        setnoProductserror("No products for this wallet")
                        showLoader(false)
                        return
                    }
                    disabledNavigate(false)
                    dispatch(selectedWalletInfo(walletinfo))
                    setCardInfo(walletinfo)
                    dispatch(productReducer(products))
                    setSelectProductsButton('')
                    setnoProductserror('')
                    showLoader(false)
                    return

                } else if (res.response !== undefined && res.response !== null) {
                    if (res.response.data && res.response.data.status && res.response.data.status === 400) {
                        setnoProductserror(res.response.data.error.message ? res.response.data.error.message : res.response.data.error ? res.response.data.error : "No Products Assigned"  )
                        return
                    }

                }
                setSelectProductsButton('grayout')
                setnoProductserror("Unable to check products. Try again later")
                return
            }
            showLoader(false)
            setSelectProductsButton('grayout')
            setnoProductserror("Unable to check farmer's products, Try again")
            return
        })
    }
    // const getAllSchools = () => {
    //     try {
    //         let pageIndex = 1;
    //         let pageSize = 100;
    //         showLoader(true);
    //         let uri = `/farmer/transactions_data?search=&pageIndex=${pageIndex}&pageSize=${pageSize}&merchantCode=${merchantInfo.MerchantID}`;
    //         ApiService.get(uri).subscribe((res) => {
    //             if (res.data !== undefined && res.data !== null) {
    //                 let trans = res.data.items;
    //                 setSchools(trans);
    //                 showLoader(false);
    //             } else {
    //                 showLoader(false);
    //                 setError("An error occurred");
    //             }
    //         });
    //     } catch (e) {
    //         showLoader(false);
    //         console.log("An error occurred" + e);
    //     } finally {
    //     }
    // };

    const schoolNameRef = useRef(null);
    const admissionNumberRef = useRef(null);
    const studentNameRef = useRef(null);
    const feeAmountRef = useRef(null);
    const paymentDescriptionRef = useRef(null);
    const [formData, setFormData] = useState({
        schoolCode: '',
        schoolName: '',
        admissionNumber: '',
        studentName: '',
        feeAmount: '',
        paymentDescription: ''
    });
    const handleInputChange = (e) => {
        if(triggerValidations){validateForm()}
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const onHandleSubmit = () => {
        if(validateForm()){
            formData.schoolName = selectedSchoolname
            formData.schoolCode = selectedSchoolcode
            dispatch(cartReducer(formData));
            navigate("/school-summary")
        }
    }

    const validateForm = () => {
        let isValid = true;

        // School Name validation
        if (!schoolNameRef.current.value) {
            setTriggerValidations(true)
            schoolNameRef.current.style.border = '1px solid red';
            isValid = false;
        } else {
            schoolNameRef.current.style.border = '1px solid #ccc';
        }

        // Admission Number validation
        if (!admissionNumberRef.current.value) {
            setTriggerValidations(true)
            admissionNumberRef.current.style.border = '1px solid red';
            isValid = false;
        } else {
            admissionNumberRef.current.style.border = '1px solid #ccc';
        }

        // Student Name validation
        if (!studentNameRef.current.value) {
            setTriggerValidations(true)
            studentNameRef.current.style.border = '1px solid red';
            isValid = false;
        } else {
            studentNameRef.current.style.border = '1px solid #ccc';
        }

        // Fee Amount validation
        if (!feeAmountRef.current.value) {
            setTriggerValidations(true)
            feeAmountRef.current.style.border = '1px solid red';
            isValid = false;
        } else if (feeAmountRef.current.value < 100 ) {
            setTriggerValidations(true)
            setError("Minimum Amount should be Ksh 100.00")
            feeAmountRef.current.style.border = '1px solid red';
            isValid = false;
        } else {
            setError("")
            feeAmountRef.current.style.border = '1px solid #ccc';
        }

        // Payment Description validation
        if (!paymentDescriptionRef.current.value) {
            setTriggerValidations(true)
            paymentDescriptionRef.current.style.border = '1px solid red';
            isValid = false;
        } else {
            paymentDescriptionRef.current.style.border = '1px solid #ccc';
        }
        return isValid;
    };

    let formattedAmount;
    if (formData.feeAmount !== null && !isNaN(formData.feeAmount) ) {
        formattedAmount = currencyFormatter(formData.feeAmount);
    } else {
        formattedAmount = ""; // or any other fallback value you prefer
    }
    // useEffect(() => {
    //     getAllSchools();
    // }, []);
    return (
        <>
            <div className="home_landing">
                {/* render header */}
                <Header />
                <div className="home_app">
                    {bal_err && <ErrorMag setBalError={setBalError} errorMagData={errorMagData} />}
                    <LeftBar />
                    <div className="home_data_template_preset">
                        <div className="verify">
                            <Loader loader={loader} />

                            <div className="verify_wrapper">
                                <h3 className="verify_wrapper_heading">
                                    Payment Details
                                </h3>

                                <form className="verify_wrapper_form">
                                    <BreadCrumbs steps={steps}></BreadCrumbs>
                                    <div className="verify_wrapper_form_container">
                                        <Container component="main" maxWidth="xs" sx={{
                                            marginLeft: "unset !important",
                                            width: "95%",
                                            maxWidth: "100% !important",
                                            paddingLeft: "unset !important",
                                            paddingRight: " unset !important"
                                        }}>
                                            <CssBaseline/>
                                            <div className="form-fields">

                                                { isVisible ? <>  <SchoolsSelector isVisible={isVisible} schools={schools} setSelectedSchoolCode={setSelectedSchoolCode} setSelectedSchoolName={setSelectedSchoolName} showisVisible = {showisVisible} ></SchoolsSelector>  </>
:
                                                <form onSubmit={e => e.preventDefault()}
                                                      noValidate
                                                      autoComplete="off"
                                                      className="container">
                                                    <label htmlFor="schoolName">Enter School Name:</label>
                                                    <div className="form-row">
                                                        <input type="search" placeholder="Gaturi Girls Secondary School"
                                                               name="schoolName"
                                                               ref={schoolNameRef}
                                                               readOnly={true}
                                                               value={selectedSchoolname}
                                                               onChange={handleInputChange}
                                                               onFocus={() => {
                                                                   showisVisible(prevState => !prevState);
                                                               }}
                                                        />
                                                        <button type="submit">Search</button>
                                                    </div>

                                                    <label htmlFor="schoolName">Admission Number: </label>
                                                    <div className="form-row-group">
                                                        <div className="form-row">
                                                            <input type="search" placeholder="S12345"
                                                                   name="admissionNumber"
                                                                   ref={admissionNumberRef}
                                                                   value={formData.admissionNumber}
                                                                   onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className="form-row">
                                                            <input type="search" placeholder="Student Name"
                                                                   name="studentName"
                                                                   ref={studentNameRef}
                                                                   value={formData.studentName}
                                                                   onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <label htmlFor="schoolName">Fee Amount: </label>
                                                    <div className="form-row-group">
                                                        <div className="form-row">
                                                            <input type="search" placeholder="Fee Amount"
                                                                   name="feeAmount"
                                                                    ref={feeAmountRef}
                                                                    inputMode="numeric"
                                                                    value={formData.feeAmount}
                                                                    pattern="[0-9]*"
                                                                    onChange={(e) => {
                                                                        if (!isNaN(e.target.value)) {
                                                                            handleInputChange(e);
                                                                        }
                                                                    }}          
                                                                    />
                                                        </div>
                                                        <div className="form-row">
                                                            <input type="search" placeholder="Payment Description"
                                                                   name="paymentDescription"
                                                                   ref={paymentDescriptionRef}
                                                                   value={formData.paymentDescription}
                                                                   onChange={handleInputChange}/>
                                                        </div>
                                                        </div>
                                                        
                                                    <div className="verify_wrapper_form_container flex-box">
                                                            {error !== "" ? <> <label htmlFor="farmer_id" className="verify_wrapper_form_label error_label invalid_id form-validate"> {error}  </label> </> : <></>}
                                                        </div>

                                                    <div className="summary_wrapper_btns">
                                                        <button onClick={() => navigate("/select-products")}
                                                                className="verify_wrapper_form_btn_verify select back">
                                                            Back
                                                        </button>
                                                        <button disabled={false}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    onHandleSubmit()
                                                                }}
                                                                className="verify_wrapper_form_btn_verify select next">
                                                            {formData.feeAmount ? `Pay `+formattedAmount : `Proceed` }
                                                        </button>
                                                    </div>

                                                        
                                                   

                                                    {/*<div className="form-row">*/}
                                                    {/*    <input type="search" placeholder="Search..."*/}
                                                    {/*           onChange={(e) => {*/}
                                                    {/*               setSchoolName(e.target.value);*/}
                                                    {/*               handleSchoolNameChange(e.target.value)*/}
                                                    {/*           }}/>*/}

                                                        {/*</div>*/}
                                                        
                                                </form>

                                                }
                                            </div>
                                        </Container>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

export default SchoolFeePayment;

